// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { I18nTranslation } from '@crehana/i18n';

// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { REGISTER_PAGE_KEY } from '@/views/Register/constants';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export type TKeys = keyof (typeof es)[typeof REGISTER_PAGE_KEY];

const locales: I18nTranslation = { es, pt, en };

export default locales;
